import React, { Component } from 'react'

import { bolt, brain, bullsEyeArrow, handRock, running, shield, star } from "../../../ui/Icon";
import PlayerAbilitySection from '../../../ui/sections/PlayerAbilitySection';

export default class MainContent extends Component {
    render() {
        return (
            <div className="main-content">
                <PlayerAbilitySection
                    cards={playerAbilities}
                />
            </div>
        )
    }
}

const items = [
    { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [{ name: 'Adel', type: 'pdf' }] },
    { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
    { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
    { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
    { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
    { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
];

const playerAbilities = [
    { title: 'Attacking', icon: bullsEyeArrow, items: [...items, ...items], columns: 2 },
    { title: 'Skills', icon: handRock, items: items },
    { title: 'Movement', icon: running, items: items },
    { title: 'Power', icon: bolt, items: items },
    { title: 'bolt', icon: brain, items: items },
    { title: 'Defence', icon: shield, items: items },
    { title: 'Goal Keeping', icon: bolt, items: items },
    { title: 'Specialities', icon: star, items: items },
];